export default "__VITE_ASSET__yKcxHUsq__"